<!--
 * @Author: 汪俊洪
 * @Date: 2022-02-28 15:39:13
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-03-24 14:09:59
 * @Description: 筛选显示列
-->
<template>
  <div class="columns">
    <i
      class="el-icon-setting"
      v-if="allFields.length"
      @click="dialogVisible = true"
    ></i>
    <el-select
      v-if="allFields.length"
      v-model="templateInfo"
      @change="getSelectedFields"
      value-key="id"
      class="sel"
      clearable
      placeholder="自定义列表"
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item.name"
        :value="item"
      >
      </el-option>
    </el-select>
    <el-dialog
      title="筛选显示列"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="802px"
    >
      <el-button-group>
        <el-button :type="type === 1 ? 'primary' : ''" @click="type = 1">
          新增模板
        </el-button>
        <el-button :type="type === 2 ? 'primary' : ''" @click="type = 2">
          管理模板
        </el-button>
      </el-button-group>
      <ColumnsAdd
        @success="type = 2"
        :sysListCode="sysListCode"
        v-if="type === 1"
      ></ColumnsAdd>
      <ColumnsList
        @handleUse="handleUse"
        :sysListCode="sysListCode"
        v-if="type === 2"
      ></ColumnsList>
    </el-dialog>
  </div>
</template>

<script>
import ColumnsAdd from './columnsAdd.vue'
import ColumnsList from './columnsList.vue'
export default {
  props: {
    code: { // 兼容需要特定值的页面
      type: String,
      default: ''
    }
  },
  components: {
    ColumnsAdd,
    ColumnsList
  },
  data () {
    return {
      dialogVisible: false,
      type: 1,
      options: [], // 模板列表
      templateInfo: '', // 模板信息
      sysListCode: '', // 页面编码
      allFields: [] // 已经配置的字段 如果没有就不显示配置
    }
  },
  async created () {
    this.sysListCode = this.code || this.$route.path.replace('/', '')
    const templateUse = JSON.parse(localStorage.getItem('templateUse') || '{}')
    const { data: res } = await this.getAllFields()
    if (res.code === 0) {
      this.allFields = res.data
    }
    const o = templateUse[this.sysListCode]
    if (o && o.userId === this.$store.state.user.userId) {
      this.templateInfo = o
      this.$emit('getSelectedFields', {
        isInit: true,
        arr: o.data
      })
    }
    this.getList()
  },
  methods: {
    // 关闭弹窗
    handleClose () {
      this.getList()
      this.dialogVisible = false
    },
    // 设置缓存
    setInfo (val) {
      const templateUse = JSON.parse(
        localStorage.getItem('templateUse') || '{}'
      )
      templateUse[this.sysListCode] = val
      localStorage.setItem('templateUse', JSON.stringify(templateUse))
    },
    // 获取所有数据后更新缓存
    updateInfo () {
      const templateUse = JSON.parse(
        localStorage.getItem('templateUse') || '{}'
      )
      const o = templateUse[this.sysListCode]
      if (!o) {
        return
      }
      this.options.some((item) => {
        if (item.id === o.id && item.userId === o.userId) {
          this.setInfo(item)
          return true
        }
        return false
      })
    },
    deleteInfo () {
      const templateUse = JSON.parse(
        localStorage.getItem('templateUse') || '{}'
      )
      delete templateUse[this.sysListCode]
      localStorage.setItem('templateUse', JSON.stringify(templateUse))
    },
    // 应用模板
    handleUse (row) {
      this.setInfo(row)
      this.dialogVisible = false
      window.location.reload()
    },
    // 获取下拉模板列表
    getList () {
      const url = `/help/user-list-mgmt/v1/user-list-templates?sysListCode=${this.sysListCode}`
      this.$http
        .get(url, {
          params: {
            currentPage: 1,
            pageSize: 1000
          }
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.options = res.data.dataList
            // 获取到数据后更新本地缓存
            this.updateInfo()
          }
        })
    },
    // 获取所有的字段 如果没有就不显示配置
    async getAllFields () {
      const url = `/help/user-list-mgmt/v1/sys-lists/${this.sysListCode}/sys-list-fields`
      return await this.$http.get(url, {
        params: {
          currentPage: 1,
          pageSize: 1000
        }
      })
    },
    // 获取自定义的字段
    getSelectedFields (val) {
      if (!val) {
        this.deleteInfo()
        this.$emit('getSelectedFields', {
          isInit: false,
          arr: []
        })
        return
      }
      const url = `/help/user-list-mgmt/v1/user-list-templates/${val.id}/selected-fields`
      this.$http.get(url).then(({ data: res }) => {
        if (res.code === 0) {
          this.$emit('getSelectedFields', {
            isInit: false,
            arr: res.data
          })
          this.setInfo({
            ...val,
            data: res.data
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.columns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 5px;
  flex: 1;
  .el-icon-setting {
    font-size: 18px;
    cursor: pointer;
  }
  .sel {
    margin: 0 8px;
    /deep/ .el-input__inner {
      height: 22px;
      line-height: 22px;
    }
    /deep/ .el-input__icon {
      line-height: 22px;
    }
    /deep/ .el-input__suffix {
      right: 0;
      transform: scale(0.8);
    }
  }
  /deep/ .el-transfer-panel {
    width: 300px;
    padding-bottom: 30px;
  }
}
</style>
